import { convertPxToRem } from "../../util-functions";
export const treezTypography = {
    // Display large in Figma
    h1: {
        fontWeight: 400,
        fontSize: convertPxToRem(45),
        lineHeight: convertPxToRem(52),
        fontFamily: "Roboto",
    },
    // Display Medium in Figma
    h2: {
        fontWeight: 400,
        fontSize: convertPxToRem(36),
        lineHeight: convertPxToRem(44),
        fontFamily: "Roboto",
    },
    // Display Small in Figma
    h3: {
        fontWeight: 400,
        fontSize: convertPxToRem(32),
        lineHeight: convertPxToRem(40),
        fontFamily: "Roboto",
    },
    // Title Large in Figma
    h4: {
        fontWeight: 400,
        fontSize: convertPxToRem(28),
        lineHeight: convertPxToRem(36),
        fontFamily: "Roboto",
    },
    // Title Medium in Figma
    h5: {
        fontWeight: 400,
        fontSize: convertPxToRem(23),
        lineHeight: convertPxToRem(32),
        fontFamily: "Roboto",
    },
    // Title Small in Figma
    h6: {
        fontWeight: 500,
        fontSize: convertPxToRem(17),
        lineHeight: convertPxToRem(24),
        fontFamily: "Roboto",
    },
    // Title Extra Small in Figma
    h7: {
        fontWeight: 500,
        fontSize: convertPxToRem(14),
        lineHeight: convertPxToRem(20),
        fontFamily: "Roboto",
    },
    // Body Large & Label Large in Figma
    largeText: {
        fontWeight: 400,
        fontSize: convertPxToRem(15),
        lineHeight: convertPxToRem(24),
        fontFamily: "Roboto",
    },
    // Label Large Link & Label Large Strong in Figma
    largeTextStrong: {
        fontWeight: 500,
        fontSize: convertPxToRem(15),
        lineHeight: convertPxToRem(24),
        fontFamily: "Roboto",
    },
    // Body Medium & Label Medium in Figma
    mediumText: {
        fontWeight: 400,
        fontSize: convertPxToRem(14),
        lineHeight: convertPxToRem(20),
        fontFamily: "Roboto",
    },
    // Label Medium Link & Label Medium Strong in Figma & titleExtraSmall
    mediumTextStrong: {
        fontWeight: 500,
        fontSize: convertPxToRem(14),
        lineHeight: convertPxToRem(20),
        fontFamily: "Roboto",
    },
    // Body Small & Label Small in Figma
    smallText: {
        fontWeight: 400,
        fontSize: convertPxToRem(12),
        lineHeight: convertPxToRem(16),
        fontFamily: "Roboto",
    },
    // Label Small Link & Label Small Strong in Figma
    smallTextStrong: {
        fontWeight: 500,
        fontSize: convertPxToRem(12),
        lineHeight: convertPxToRem(16),
        fontFamily: "Roboto",
    },
    // Label Extra Small in Figma
    extraSmallText: {
        fontWeight: 400,
        fontSize: convertPxToRem(11),
        lineHeight: convertPxToRem(16),
        fontFamily: "Roboto",
    },
    // Label Extra Small Link & Label Extra Small Strong in Figma
    extraSmallTextStrong: {
        fontWeight: 500,
        fontSize: convertPxToRem(11),
        lineHeight: convertPxToRem(16),
        fontFamily: "Roboto",
    },
    // All Caps Large Caption in Figma
    largeCapitalizedText: {
        fontWeight: 500,
        fontSize: convertPxToRem(13),
        lineHeight: convertPxToRem(16),
        letterSpacing: "0.015rem",
        fontFamily: "Roboto",
        textTransform: "uppercase",
    },
    // All Caps Large Strong & All Caps Large Strong Link in Figma
    largeCapitalizedTextStrong: {
        fontWeight: 700,
        fontSize: convertPxToRem(13),
        lineHeight: convertPxToRem(16),
        letterSpacing: "0.015rem",
        fontFamily: "Roboto",
        textTransform: "uppercase",
    },
    // All Caps Small Strong in Figma
    smallCapitalizedTextStrong: {
        fontWeight: 700,
        fontSize: convertPxToRem(10),
        lineHeight: convertPxToRem(12),
        letterSpacing: "0.015rem",
        fontFamily: "Roboto",
        textTransform: "uppercase",
    },
};
